import { SidenavRoutes } from './../constans/side-nav.routes';
import { MenuTop } from './../interfaces/menu-top.interface';
import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription ,  Subject ,  BehaviorSubject , Observable} from 'rxjs';
import { MenuNavRoutes } from '../constans/menu-nav.routes';
import { Child } from '../interfaces/child.interface';
import { PanelColors } from '../constans/panel-colors';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DataSaveService } from './data-save.service';
import { TranslateService } from '@ngx-translate/core';
import { CalendarPrime } from '../constans/calendar-primeng';
import { ChildsMenuEnum } from '../enums/childs-menu.enum';
import { BootController } from '../../../boot-control';
import { LoadingService } from '../../shared/loading/loading.service';
import { CustomRouteReuseStategy } from '../classes/custom-route-reuse';
import { MarcadorFavoritoService } from '../../shared/components/marcardor-favorito/marcador-favorito.service';
import * as moment from 'moment';
import {ConfirmService} from '../../shared/confirm/confirm.service';
import {map} from 'rxjs/operators';


@Injectable()
export class AuthService {
    url_getCulture = `${environment.ENTORNO}${environment.SessionService.URL}${environment.SessionService.ENDPOINT.GetCurrentCulture}`;

    WorkingDateDiff: string;
    moduloSubject = new Subject<MenuTop>();
    public _dataContents: any;
    public _CompanyCode: string;
    public _CustomerCode: string;
    public _CustomerId: string;
    public _aplicationType: any;
    public _pais: string;
    public _roleUser: number; //role para los tipos de acceso
    public _filial: string;
    public _filialComplete: string;
    public _headerMessage: string;
    public initialState: any;
    subsModalConfirm: Subscription;
    currentColor = '#6c92e8';
    tipoModulo: string;
    public _navegador: string;
    public CLIENTCODE: string;
    seleccionar: string;
    public datosImprimir = new BehaviorSubject<any>({});
    public idiomaCalendar: any;
    modulesActives: any;
    private _validExtensions: string[] = null;
    constructor(
        private translateService: TranslateService,
        private ngZone: NgZone,
        private _dataSaveService: DataSaveService,
        private http: HttpClient,
        private loading: LoadingService,
        private favs: MarcadorFavoritoService,
        private router: Router,
        private confirmService: ConfirmService
    ) { }
    httpOptions = {
        withCredentials: true,
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    isChildVisible(child: ChildsMenuEnum) {
        let isVisible = false;
        const m = sessionStorage.getItem('menuTop');
        if (m) {
            const menu = JSON.parse(m);
            for (const modulo of menu) {
                for (const c of modulo.Childs) {
                    if (c.ID === child) {
                        isVisible = true;
                        break;
                    }
                }
                if (isVisible) { break; }
            }
        }
        return isVisible;
    }

    setModulesActives(value: any) {
        this.modulesActives = value;
    }

    getCustomCollectionManagement() {
        const key = sessionStorage.getItem('userProfile');

        if (key) {
            const usuario = JSON.parse(key);
            return usuario.Company.CustomCollectionManagement;
        }
        return false;
    }

    getActiveWarehouse() {
        const key = sessionStorage.getItem('userProfile');
        if (key) {
            const usuario = JSON.parse(key);
            return usuario.ActiveWareHouseNumber;
        }

        return 1;
    }

    getDefaultMaterialChangeCode() {
        const key = sessionStorage.getItem('userProfile');
        if (key) {
            const usuario = JSON.parse(key);
            return usuario.Company.CompanyBrandManaged.MaterialChangeCode;
        }

        return 1;
    }

    getDefaultVat() {
        const key = sessionStorage.getItem('userProfile');
        if (key) {
            const usuario = JSON.parse(key);
            return usuario.VATCodeRegistry.VatCode;
        }

        return '02';
    }

    getDefaultVatCompany() {
        const key = sessionStorage.getItem('userProfile');
        if (key) {
            const usuario = JSON.parse(key);
            return usuario.Company.VatCode;
        }

        return '02';
    }

    getDefaultOperationType() {
        const key = sessionStorage.getItem('userProfile');
        if (key) {
            const usuario = JSON.parse(key);
            return usuario.Company.DefaultOperationType;
        }

        return '***';
    }

    getInternalOperationType() {
        const key = sessionStorage.getItem('userProfile');
        if (key) {
            const usuario = JSON.parse(key);
            return usuario.Company.InternalOperationType;
        }

        return 'INT';
    }

    getDefaultProviderCode() {
        const key = sessionStorage.getItem('userProfile');
        if (key) {
            const usuario = JSON.parse(key);
            return usuario.Company.DefaultProviderCode;
        }

        return '024633U-2';
    }

    getDefaultBrand() {
        const key = sessionStorage.getItem('userProfile');
        if (key) {
            const usuario = JSON.parse(key);
            return usuario.GeneralConfiguration.DefaultPRBrand;
        }

        return 'CIT';
    }


    getSeviboxURL() {
        const key = sessionStorage.getItem('userProfile');
        if (key) {
            const usuario = JSON.parse(key);
            // return usuario.Company.APVPRConfiguration.URLCSSB.substring(0, usuario.Company.APVPRConfiguration.URLCSSB.length - 1);
            return usuario.Company.APVPRConfiguration.URLCSSB;
        }
        return '';
    }

    setCalendar(valor) {
        this.idiomaCalendar = CalendarPrime[valor];
        sessionStorage.setItem('idiomaCalendar', JSON.stringify(this.idiomaCalendar));
    }

    getCalendar() {
        this.idiomaCalendar = sessionStorage.getItem('idiomaCalendar') ? JSON.parse(sessionStorage.getItem('idiomaCalendar')) : null;
        return this.idiomaCalendar;
    }


    getCalendarLocale() {
        return sessionStorage.getItem('culture') ? CalendarPrime[JSON.parse(sessionStorage.getItem('culture'))] : CalendarPrime['es'];
    }

    observerdatosImprimir() {
        return this.datosImprimir.asObservable();
    }
    setdatosImprimir(value) {
        this.datosImprimir.next(value);
    }


    getCompanyCode() {
        this._CompanyCode = this._CompanyCode ? this._CompanyCode : JSON.parse(sessionStorage.getItem('CompanyCode'));
        return this._CompanyCode;
    }

    setCompanyCode(data: any) {
        sessionStorage.setItem('CompanyCode', JSON.stringify(data));
        this._CompanyCode = data;
    }

    getCustomerCode() {
        this._CustomerCode = this._CustomerCode ? this._CustomerCode : JSON.parse(sessionStorage.getItem('CustomerCode'));
        return this._CustomerCode;
    }

    setNavegador(data: any) {
        sessionStorage.setItem('navegador', JSON.stringify(data));
        this._navegador = data;
    }

    getNavegador() {
        this._navegador = this._navegador ? this._navegador : JSON.parse(sessionStorage.getItem('navegador'));
        return this._navegador;
    }

    setCustomerCode(data: any) {
        sessionStorage.setItem('CustomerCode', JSON.stringify(data));
        this._CustomerCode = data;
    }

    getCustomerId() {
        this._CustomerId = this._CustomerId ? this._CustomerId : JSON.parse(sessionStorage.getItem('_CustomerId'));
        return this._CustomerId;
    }

    setCustomerId(data: any) {
        sessionStorage.setItem('_CustomerId', JSON.stringify(data));
        this._CustomerId = data;
    }

    getAplicationType() {
        this._aplicationType = this._aplicationType ? this._aplicationType : JSON.parse(sessionStorage.getItem('AplicationType'));
        return this._aplicationType;
    }

    setAplicationType(data: any) {
        sessionStorage.setItem('AplicationType', JSON.stringify(data));
        this._aplicationType = data;
    }

    getDataContents() {
        this._dataContents = this._dataContents ? this._dataContents : JSON.parse(sessionStorage.getItem('userProfile'));
        return this._dataContents;
    }

    setDataContents(data: any) {
        sessionStorage.setItem('userProfile', JSON.stringify(data));
        this._dataContents = data;
    }

    getModulo() {
        return this.moduloSubject.asObservable();
    }

    setUserProfile(userProfile) {
        sessionStorage.setItem('userProfile', JSON.stringify(userProfile));
    }

    getUserProfile() {
        return JSON.parse(sessionStorage.getItem('userProfile'));
    }

    setUserRole(userRole) {
        sessionStorage.setItem('userRole', JSON.stringify(userRole));
    }

    goToModuleOption(module: number, option: number) {
        const moduleObject = this.getUserProfile().AppModules[module];
        this.setCurrentModule(moduleObject);
        this.setDataOptionMenu(moduleObject.Childs[option]);
        this.setModuloActivo(module);
        this.router.navigate([moduleObject.Childs[option].route]);
    }

    setUserPermissionsList(permissionsList) {
        sessionStorage.setItem('permissionsList', JSON.stringify(permissionsList));
    }

    getUserPermissionsList() {
        const auxPermissionsList = sessionStorage.getItem('permissionsList');
        if (auxPermissionsList !== 'undefined') {
            return JSON.parse(sessionStorage.getItem('permissionsList'));
        } else {
            return [];
        }
        // return JSON.parse(sessionStorage.getItem('permissionsList'));
    }

    getUserRole() {
        // return JSON.parse(sessionStorage.getItem('userRole'));
        //De momento hasta aclarar que códigos corresponden a que privilegios.
        // Vamos a moquear desde aqui el retorno para el modo consulta si es necesario
        //he creado un role en modo consulta en REc con codigo 33, usare este

        return false;
    }

    getDataColor() {
        return JSON.parse(sessionStorage.getItem('colorModulo'));
    }

    setDataColors(data: any) {
        sessionStorage.setItem('colorModulo', JSON.stringify(data));
    }

    isAuthenticated() {
        if (sessionStorage.getItem('userProfile')) {
            return true;
        }
        return false;
    }

    getClientCode() {
        this.CLIENTCODE = this.CLIENTCODE ? this.CLIENTCODE : JSON.parse(sessionStorage.getItem('CLIENTCODE'));
        return this.CLIENTCODE;
    }

    setClientCode(data: any) {
        sessionStorage.setItem('CLIENTCODE', JSON.stringify(data));
        this.CLIENTCODE = data;
    }

    configureRoles(userProfile, dataProfile) {
        this.setClientCode(userProfile.Company.CLIENTCODE);
        const wd = userProfile.WorkingDate;
        const hoy = Number(moment().format('YYYYMMDD'));
        const dateWorking = Number(moment(wd).format('YYYYMMDD'));
        this.WorkingDateDiff = (hoy - dateWorking) !== 0 ? moment(wd).format('DD/MM/YYYY') : undefined;

        const appModules = userProfile.AppModules;
        const menuTop: MenuTop[] = []; //con code

        for (const modules of appModules) {
            if (modules.Childs !== null && modules.Childs.length > 0) {
                const mt = modules;
                mt.route = MenuNavRoutes[mt.Code];
                const childs: Child[] = [];
                for (const child of mt.Childs) {
                    child.route = SidenavRoutes[child.ID];
                    childs.push(child);
                }
                mt.Childs = childs;
                menuTop.push(mt);
            }
        }
        sessionStorage.setItem('menuTop', JSON.stringify(menuTop));


        let route: string = '';
        if (dataProfile.IsDefinedBasicVATConfiguration === false) {
            const menu = menuTop.filter(menu => menu.Code === 99)[0];
            this.setDataOptionMenu(menu.Childs[0]);
            this.setCurrentModule(menu);

            this.setModuloActivo(menu.Code);
            this.actualizarColor(menu.Code);
            this.descripcionModulo(menu.Code);

            route = '/dms/panel-control/taller'
        } else {
            this.setDataOptionMenu(menuTop[0].Childs[0]);
            this.setCurrentModule(menuTop[0]);

            this.setModuloActivo(menuTop[0].Code);
            this.actualizarColor(menuTop[0].Code);
            this.descripcionModulo(menuTop[0].Code);

            route = menuTop[0].Childs[0].route;
        }

        /* Cargo datos del perfil de usuario */
        this.setUserProfile(userProfile);
        this.setUserFavorites(userProfile.Favorites);
        this.setCustomerCode(userProfile.Company.ContractNumber);
        this.setCustomerId(userProfile.Company.DefaultWarrantyCustomerCode);
        this.setCompanyCode(userProfile.Company.CompanyId);

        // Inicio la navegacion al punto de entrada de la aplicacion
        this.router.navigate([route]).then(_ => {
            if (userProfile.Company.TicketBAIEnabled && userProfile.ShowHeaderMessage && moment(new Date()).isAfter(userProfile.WorkingDate, 'day')) {
                this.translateService.get([
                    'labels.alert',
                    'labels.aceptar',
                ]).subscribe(res => {
                    this.confirmService.confirmConfig = {
                        title: res['labels.alert'],
                        message: userProfile.HeaderMessage,
                        textButtonAccept: res['labels.aceptar'],
                        // textButtonCancel: res['labels.no'],
                        onButtonAccept: () => {
                        },
                        // onButtonCancel: () => {
                        // }
                    };
                    this.confirmService.showConfirm(true);
                });
            }


        });

        this.setUserRole(userProfile.CurrentUser.Role);

        if (userProfile.PermissionsList) {
            this.setUserPermissionsList(userProfile.PermissionsList);
        }

    }

    setUserFavorites(favorites) {
        sessionStorage.setItem('userFavorites', JSON.stringify(favorites));
        this.favs.setFavorites(favorites);
    }

    descripcionModulo(moduloActivo) {
        switch (moduloActivo) {
            case 0:
                this.tipoModulo = 'moduloPrincipal';
                break;
            case 1:
                this.tipoModulo = 'moduloGeneral';
                break;
            case 2:
                this.tipoModulo = 'moduloAlmacén';
                break;
            case 3:
                this.tipoModulo = 'moduloTaller';
                break;
            case 4:
                this.tipoModulo = 'moduloFacturas';
                break;
            case 5:
                this.tipoModulo = 'moduloConectividad';
                break;
            case 6:
                this.tipoModulo = 'moduloContabilidad';
                break;
            case 7:
                this.tipoModulo = 'moduloVC/VO';
                break;
            case 8:
                this.tipoModulo = 'moduloGRC';
                break;
            case 9:
                this.tipoModulo = 'Productividad';
                break;
            case 99:
                this.tipoModulo = 'panelControl';
                break;
        }
    }

    actualizarColor(moduloActivo) {
        this.currentColor = PanelColors[moduloActivo];
        this.setDataColors(this.currentColor);
    }

    getDataPais() {
        const culture = sessionStorage.getItem('culture') ? JSON.parse(sessionStorage.getItem('culture')) : null;
        this._pais = culture;
        return this._pais;
    }

    getHeaderMessage() {
        const headerMessageData = sessionStorage.getItem('headerMessage');
        let message;
        try {
            message = JSON.parse(headerMessageData);
        } catch (e) {
            message = '';
        }
        this._headerMessage = message;
        return this._headerMessage;
    }

    setHeaderMessage(userProfile) {
        const message = userProfile.HeaderMessage;
        sessionStorage.setItem('headerMessage', JSON.stringify(message));
    }

    getFilialComplete(): any {
        this._filialComplete = sessionStorage.getItem('initialState') ? JSON.parse(sessionStorage.getItem('initialState')) : null;
        return this._filialComplete;
    }

    getFilial(): string {
        const pais: String = ((this.getDataPais()).toUpperCase());
        this.initialState = sessionStorage.getItem('initialState') ? JSON.parse(sessionStorage.getItem('initialState')) : null;
        this._filial = (this.initialState.filial.toString()).substring(0, (this.initialState.filial.indexOf(pais)));
        return this._filial;
    }

    filialER(): boolean {
        let isFilialER: Boolean = false;

        const pais: String = ((this.getDataPais()).toUpperCase());
        const filial: String = this.getFilial();

        if ((filial === 'ER') || (filial === 'ECS')) {
            return (isFilialER = true);
        } else {
            return (isFilialER = false);
        }
    }

    getDataOptionMenu() {
        return JSON.parse(sessionStorage.getItem('optionMenu'));
    }

    setDataOptionMenu(data: Child) {
        sessionStorage.setItem('optionMenu', JSON.stringify(data));
    }

    setCurrentModule(modulo) {
        this.moduloSubject.next(modulo);
        sessionStorage.setItem('currentModule', JSON.stringify(modulo));
    }

    getCurrentModule() {
        return JSON.parse(sessionStorage.getItem('currentModule'));
    }

    getModuloActivo() {
        return Number(JSON.parse(sessionStorage.getItem('moduloActivo')));
    }

    setModuloActivo(data: number) {

        this._dataSaveService.setModule(data);
        sessionStorage.setItem('moduloActivo', JSON.stringify(data));
        this.actualizarColor(data);
    }

    logout() {
        this.loading.setLoading(true);
        setTimeout(() => {
            this.modulesActives = undefined;
            CustomRouteReuseStategy.handlers = {};
            sessionStorage.clear();
            localStorage.clear();
            this.ngZone.runOutsideAngular(() => BootController.getbootControl().restart());
            this.router.navigateByUrl('/');
        }, 0);
    }

    getCulture() {
        return this.http.post(this.url_getCulture, '', this.httpOptions);
    }

    getUserRoleRspAdmin() {
        return JSON.parse(sessionStorage.getItem('userRole'));
    }

    // CUrrent Date of Login
    getWorkingDate() {
        const user = JSON.parse(sessionStorage.getItem('userProfile'));
        if (user) {
            return user.WorkingDate;
        }
        return null;
    }

    getReceptionistCode() {
        const userProfile = sessionStorage.getItem('userProfile');
        let userProfileObj;
        if (userProfile) {
            userProfileObj = JSON.parse(userProfile);
            if (userProfileObj.Receptionist) {
                return userProfileObj.Receptionist.ReceptionistCode;
            } else {
                return null;
            }
        }
        return null;
    }

    getReceptionistName() {
        const userProfile = sessionStorage.getItem('userProfile');
        let userProfileObj;
        if (userProfile) {
            userProfileObj = JSON.parse(userProfile);
            if (userProfileObj.Receptionist) {
                return userProfileObj.Receptionist.ReceptionistName;
            } else {
                return null;
            }
        }
        return null;
    }

    getVATCodeDefault() {
        const vatDefault = JSON.parse(sessionStorage.getItem('userProfile'));
        if (vatDefault && vatDefault.VATCodeRegistry && vatDefault.VATCodeRegistry.VatCode) {
            return vatDefault.VATCodeRegistry.VatCode;
        } else {
            return '';
        }
    }

    getVATPercentageDefault() {
        const vatDefault = JSON.parse(sessionStorage.getItem('userProfile'));
        if (vatDefault && vatDefault.VATCodeRegistry && vatDefault.VATCodeRegistry.VatPercentage) {
            return vatDefault.VATCodeRegistry.VatPercentage;
        } else {
            return 0;
        }
    }

    getBackgroundInvoice(type = 'BackgroundInvoice'): boolean {
        const userProfile = JSON.parse(sessionStorage.getItem('userProfile'));
        if (userProfile && userProfile.Company && userProfile.Company[type] !== undefined) {
            return userProfile.Company[type];
        }
        return true;
    }

    getSignature(signature: string = 'ESignatureInvoice'): boolean {
        const userProfile = JSON.parse(sessionStorage.getItem('userProfile'));
        if (userProfile && userProfile.Company && userProfile.Company[signature]) {
            return userProfile.Company[signature];
        }
        return false;
    }

    getSimboloSinMarca() {
        const userProfile = JSON.parse(sessionStorage.getItem('userProfile'));
        if (userProfile && userProfile.Company && userProfile.Company['PrintNotBrandChar']) {
            return userProfile.Company['PrintNotBrandChar'];
        }
        return false;
    }

    getDefaultCustomerCode() {
        const userProfile = sessionStorage.getItem('userProfile');
        let userProfileObj;
        if (userProfile) {
            userProfileObj = JSON.parse(userProfile);
            if (userProfileObj.Company) {
                return userProfileObj.Company.DefaultCustomerCode;
            } else {
                return null;
            }
        }
        return null;
    }

    getIsReportingEnabled() {
        return JSON.parse(sessionStorage.getItem('isReportingEnabled'))
    }

    setIsReportingEnabled(enabled: boolean) {
        sessionStorage.setItem('isReportingEnabled', JSON.stringify(enabled));
    }

    getIsAccountingEnabled() {
        return JSON.parse(sessionStorage.getItem('isAccountingEnabled'))
    }

    setIsAccountingEnabled(enabled: boolean) {
        sessionStorage.setItem('isAccountingEnabled', JSON.stringify(enabled));
    }

    getValidExtensions(hasDot: boolean = false): Observable<string[]> {
        return new Observable<string[]>(subscriber => {
            const emit = () => {
                subscriber.next(hasDot ? this._validExtensions : this._validExtensions.map(extension => {return extension.substring(1)}));
                subscriber.complete();
            };

            if (this._validExtensions === null) {
                this._validExtensions = [];
                this.http.post<any>(`${environment.ENTORNO}Services/BaseServices/MediaFilesService.svc/GetValidMediaFiles`, {}).pipe(map(result => {
                    return result.Response;
                })).subscribe(extensions => {
                    this._validExtensions = extensions;
                    emit();
                });
            } else {
                emit();
            }
        });
    }}
